var map = {
	"./bmdcfgts/logo.svg": "6f2b",
	"./digicash/logo.svg": "cc31",
	"./fgtsbmp/logo.svg": "ab8c",
	"./girocred_fgts/logo.svg": "5f40",
	"./lucash_fgts/logo.svg": "4f27",
	"./master3fgts/logo.svg": "0cda",
	"./pagol/logo.svg": "39a9",
	"./segue/logo.svg": "3c06",
	"./souzacred/logo.svg": "f1c0",
	"./v12_fgts/logo.svg": "ed6d",
	"./viainvest_fgts/logo.svg": "6f6c",
	"./volus/logo.svg": "3bb5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "62f4";